<template>
  <Simple>
    <div class="login-container container">
      <LoginCard @onSignin="onSignin" :signInPrompt="textSigninPrompt" :bannerMessage="loginMessage" />
      <ResetPasswordModal :modalId="modalId" />
      <hr>
      <p class="pull-left">No account? <a class="no-href" @click.prevent="redirectToSignUp">Sign up</a></p>
      <p @click="showPasswordResetModal" class="pull-right"><a class="no-href" id="reset">Reset password</a></p>
    </div>
  </Simple>
</template>

<script>
import Simple from '../layouts/Simple'
import LoginCard from '../components/LoginCard'
import ResetPasswordModal from '../components/Modals/ResetPasswordModal'
import { mapGetters } from 'vuex'
import DataService from '../services/DataService';
const ds = DataService.getInstance()

export default {
  name: 'Login',
  components: {
    Simple,
    LoginCard,
    ResetPasswordModal
  },
  data () {
    return {
      modalId: 'resetPasswordModal'
    }
  },
  props: {
    redirect: String
  },
  beforeRouteEnter (to, from, next) {
    if (from.path === '/onboard') {
      return next();
    }
    const defaultRedirectOnQuery = to.query.redirect;
    const newRedirectPath = from.path;
    const queryParamsString = new URLSearchParams(from.query).toString();


    next(vm => {
      const finalRedirect = defaultRedirectOnQuery || newRedirectPath;
      const redirectWithParams = `${finalRedirect}?${queryParamsString}`;

      vm.$router.replace({ path: to.path, query: { redirect: redirectWithParams } });
    })
  },
  methods: {
    showPasswordResetModal () {
      this.$bvModal.show(this.modalId)
    },
    redirectToSignUp () {
      const url = this.redirect ? `/signup?redirect=${this.redirect}` : '/signup';
      this.$router.push(url);
    },
    async onSignin () {
      const defaultLoggedInUrl = '/events';
      const pageUrl = this.redirect || defaultLoggedInUrl;
      const acceptedTOS = await ds.hasUserAcceptedLatestTOS();
      if (acceptedTOS) {
        await this.$router.push(pageUrl);
        this.$localStorage.set('signinRedirect', pageUrl);
      } else {
        const tosUrl = this.redirect ? `/tos?redirect=${this.redirect}` : '/tos'
        this.$localStorage.set('signinRedirect', tosUrl);
        await this.$router.push(tosUrl);
      }
      window.location.reload();
    }
  },
  computed: {
    ...mapGetters('settings', [
      'textSigninPrompt',
      'bannerMessage',
      'showBannerMessage',
      'distributionUrl',
      'distributionEnabled',
    ]),
    loginMessage () {
      let message = ''
      if (this.showBannerMessage) {
        message = this.bannerMessage
      }

      return message
    }
  }
}
</script>
